import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import { SystemText } from '@salesperformanceint/e4shared';

export const PrismPerson = props => {
    const { data, user, downline, history } = props;

    const isManager = user.id === data.id || downline?.find(d => d.id === data.id);
    const isAdministrator = user.administrator;

    const goTo = (event, link) => {
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
        history.push(link);
    };

    const st = (s, x) => SystemText(`Search/Results/Person/${s}`, x);

    const CreateLinks = () => {
        if (data.id === user.id) {
            return {
                teamMember: `/welcome`,
                team: `/search?manager=${data.id}&name=${data.name}`,
            };
        }

        return {
            teamMember: `/team-member/${data.id}`,
            team: `/search?manager=${data.id}&name=${data.name}`,
        };
    };

    const links = CreateLinks();

    return (
        <div className="search-result box" style={{ cursor: 'default' }}>
            <div className="image-holder hidden-xs">
                <BlobImage folder="avatar" initials={data.initials} src={data.image} width="75" height="75" />
            </div>
            <div>
                <label className="label label-primary">
                    <i className="mr10 fa fa-user" />
                    {st('Title')}
                </label>
                <h2>{data.name}</h2>
                {data.manager_Fullname && (
                    <div className="mb2">
                        {st('Manager')}:{' '}
                        <Link to={`/search/${data.manager_Fullname}`}>
                            <BlobImage
                                folder="avatar"
                                initials={data.manager_Initials}
                                src={data.manager_Avatar}
                                className="mr5 ml5"
                                width="20"
                                height="20"
                            />
                            {data.manager_Fullname}
                        </Link>
                    </div>
                )}
                {data.job_Title && <span>{data.job_Title}</span>}
                {data.departments && (
                    <span>
                        {st('Department')} : {data.departments}
                    </span>
                )}
                {data.locations && (
                    <span>
                        {st('Location')} : {data.locations}
                    </span>
                )}

                <div className="table-btns mt5">
                    {(isManager || isAdministrator) && (
                        <button onClick={event => goTo(event, links.teamMember)} className="btn btn-default btn-xs">
                            {st('ViewProfile')}
                        </button>
                    )}
                    {data.isManager && (isManager || isAdministrator) && (
                        <button onClick={event => goTo(event, links.team)} className="btn btn-default btn-xs">
                            {st('Team')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default withRouter(PrismPerson);
